require('../export');

ya.music.Audio.fx.volumeLib = require('./volume-lib');
